import { useState } from "react";
import { LiaBarsSolid } from "react-icons/lia";
import { NavigationMobile } from "~/components/organisms/navigation-bar/NavigationMobile";
import { NavigationDesktop } from "~/components/organisms/navigation-bar/NavigationDesktop";

export default function Navigation({ isAuthenticated }: { isAuthenticated?: boolean }) {
    const [open, setOpen] = useState<boolean>(false);
    const overlay = (
        <div
            data-testid="mobile-navigation-overlay"
            className="fixed left-0 top-0 z-[60] h-screen w-screen animate-fade overflow-scroll bg-white transition-all sm:hidden"
        >
            <NavigationMobile onClose={() => setOpen(false)} isAuthenticated={isAuthenticated} />
        </div>
    );
    return (
        <>
            {open && overlay}
            <nav className="hidden flex-row gap-8 sm:flex" aria-label="Desktop Navigation Menu">
                <NavigationDesktop isAuthenticated={isAuthenticated} />
            </nav>
            <LiaBarsSolid
                className="absolute left-4 cursor-pointer text-blue-80 sm:hidden"
                size={34}
                onClick={() => setOpen(o => !o)}
                aria-label="Mobile Navigation Menu"
                data-testid="mobile-navigation-toggle"
            />
        </>
    );
}
